<aside class="aside" [ngClass]="{'active-mobile-menu': activeMobileMenu}">
  <nav class="aside__nav">
    @for (item of navItems; track item) {
      @if (item.subnav) {
        <a class="aside__nav__item" (click)="setSubnavState($event, item)">
          <mat-icon size-large>{{item.icon}}</mat-icon> {{item.label}}
          <mat-icon size-large class="toggle-icon">
            {{item.isSubnavOpen ? 'expand_less' : 'expand_more'}}
          </mat-icon>
        </a>
        @if (item.isSubnavOpen) {
          @for (item of item.subnav; track item) {
            <div class="aside__subnav">
              <a class="aside__subnav__item" [class.icon-plus]="item.iconPlus" routerLink={{item.route}} routerLinkActive="active">
                {{item.label}}
              </a>
            </div>
          }
        }
      } @else {
        <a class="aside__nav__item" routerLink={{item.route}} routerLinkActive="active" [routerLinkActiveOptions]={exact:true}>
          <mat-icon size-large>{{item.icon}}</mat-icon> {{item.label}}
          @if (item.tag) {
            <span class="aside__nav__item__tag">{{item.tag}}</span>
          }
        </a>
      }
    }
  </nav>
</aside>
